import react, { useState, useEffect} from 'react';
import { Modal, Form, Select, Checkbox, Input } from 'antd';
import useFetch from '../../../../commons/useFetch';
import MediaModal from './MediaModal';
import EndowModal from './EndowModal';
import Slider from "react-slick";
function BookingRoom({ valueSearch, dateValue}) {
    
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [day, setDay] = useState()
    const [night, setNight] = useState()
    
    const { data: Medias } = useFetch('https://my-json-server.typicode.com/hongngat/db-smarthotel-booking/Medias/'+valueSearch[0].id);
    const Option = Select;
    const { TextArea } = Input;
    const showMediaModal = () => {
        setIsModalVisible(true)
    }
    const handleCancel = () => {
        setIsModalVisible(false)
    }
    const [endowModal, setEndowModal] = useState(false);
    const showEndowModal = () => {
        setEndowModal(true)
    }

    window.addEventListener('resize', handleResize)
    function handleResize() {
        setScreenWidth(window.innerWidth)
    }

    

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: (
            <div>
                <img src="/images/ic_prev1.png" />
            </div>
        ),
        nextArrow: (
            <div>
                <img src="/images/ic_next1.png" />
            </div>
        ),
    };
    
    useEffect(() => {
        const date1 = new Date(dateValue[0]);
        const date2 = new Date(dateValue[1]);
        const oneDay = 24 * 60 * 60 * 1000; 

        const dayNumber = Math.round(Math.abs((date2 - date1) / oneDay));
        
    if (dayNumber===0){
        setDay(dayNumber + 1)
        setNight(dayNumber + 1)
        }
        else{
        setDay(dayNumber)
        setNight(dayNumber - 1)
        }
    }, [day,night])
    return (
        <>
            <div className="bookingRoom">
                <div className="roomInfo">
                    <div className="row ">
                        <div className="col-lg-7 col-md-7">
                            {screenWidth < 768 ?
                                (<div className="slideMedia">
                                    <Slider {...settings}>
                                        {Medias.image && Medias.image.map(item=>{
                                            return(
                                                <div className="item">
                                                    <img className="img-fluid" src={item.photo} alt="" />
                                                </div>
                                            )
                                        })}
                                    </Slider>
                                </div>)
                                :
                                (<div className="row">
                                    <div className="col-lg-9 col-md-9">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 colBox">
                                                <img className="img-fluid" src="/images/hotels-1612754408929.png" alt="" />
                                            </div>
                                            <div className="col-lg-6 col-md-6 colBox">
                                                <img className="img-fluid" src="/images/hotels-1612754408934.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 colBox">
                                        <div className="album">
                                            <img className="img-fluid" src="images/hotels-1612754408936.png" alt="" />
                                            <div className="albumQuatity" onClick={showMediaModal}>
                                                <span>+</span><span>16</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>)
                            }
                        </div>
                        <div className="col-lg-5 col-md-5">
                            <div className="infoBox">
                                <h5 className="hotelName">{valueSearch[0].name}</h5>
                                <div className="dateTime">
                                    <div className="time"><img className="img-fluid" src="/images/ic_date.png" alt="" /><span>{dateValue[0]} - {dateValue[1]}</span></div>
                                    <div className="night"><span>{day} ngày {night} đêm</span></div>
                                </div>
                                <div className="location"><img className="img-fluid" src="/images/ic_location1.png" alt="" /><span>{valueSearch[0].address}</span></div>
                                <div className="line"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bookingUser">
                    <div className="avatarForm">
                        <img className="img-fluid" src="images/avatar.png" alt="" />
                    </div>
                    <div className="slogan">Chào mừng JO đã quay trở lại. Có rất nhiều thứ đã thay đổi khi JO rời đi nhưng chúng tôi vẫn ở đây đợi bạn hoàn tất đặt phòng!</div>
                </div>
                <div className="bookingInfo formSyleInfo">
                    <Form>
                        <div className="row">
                            <div className="col-lg-7 col-md-7">
                                <div className="bookingInfoStyle">
                                    <div className="guest_room">
                                        <h5 className="title">Khách - phòng</h5>
                                        <div className="guest_roomItem">
                                            <Form.Item label="Số khách" name="guestNumber" className="selectStyle">
                                                <Select defaultValue="1" >
                                                    <Option value="1">1</Option>
                                                    <Option value="2">2</Option>
                                                    <Option value="3" >3</Option>
                                                    <Option value="4">4</Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item label="Số phòng" name="roomNo" className="selectStyle">
                                                <Select defaultValue="1" >
                                                    <Option value="1">1</Option>
                                                    <Option value="2">2</Option>
                                                    <Option value="3" >3</Option>
                                                    <Option value="4">4</Option>
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>

                                    <div className="serviceOther">
                                        <h5 className="title">Dịch vụ khác</h5>
                                        <div className="serviceOtherItem">
                                            <Form.Item name="" className="checkBoxService inputStyle">
                                                <Checkbox name="space" className="checkBoxStyle">Không gian tăng thêm</Checkbox>
                                            </Form.Item>
                                            <div className="serviceOtherContent">
                                                <Form.Item name="quatity" className="quatity selectStyle" label="Số lượng">
                                                    <Select defaultValue="1" >
                                                        <Option value="1">1</Option>
                                                        <Option value="2">2</Option>
                                                        <Option value="3" >3</Option>
                                                        <Option value="4">4</Option>
                                                    </Select>
                                                </Form.Item>
                                                <div className="rate">200,000 VND/phòng/đêm</div>
                                            </div>
                                            
                                        </div>
                                        <div className="serviceOtherItem">
                                            <Form.Item className="checkBoxService inputStyle">
                                                <Checkbox name="breakfast" className="checkBoxStyle">Ăn sáng</Checkbox>
                                            </Form.Item>
                                            <div className="serviceOtherContent ">
                                                <Form.Item name="mealsNumber" className="mealsNumber selectStyle" label="Số bữa">
                                                    <Select defaultValue="1" >
                                                        <Option value="1">1</Option>
                                                        <Option value="2">2</Option>
                                                        <Option value="3" >3</Option>
                                                        <Option value="4">4</Option>
                                                    </Select>
                                                </Form.Item>
                                                <div className="rate">200,000 VND/phòng/đêm</div>
                                            </div>

                                            
                                        </div>
                                    </div>
                                    <div className="note">
                                        <h5>JO ƠI, BẠN CÓ YÊU CẦU ĐẶC BIỆT?</h5>
                                        <p>Chút yêu cầu nhỏ bỏ ngỏ cùng nhau, để cuộc hẹn thêm trọn vẹn hơn nhé JO ơi !</p>
                                    </div>
                                    <Form.Item className="TextAreaStyle">
                                        <TextArea rows={4} placeholder="Cho Mandala  biết yêu cầu của bạn" />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-5">
                                <div className="bookingPayment">
                                    <div className="bookingPaymentStyle" style={{ backgroundImage: `url('/images/wave.png')` }}>
                                        <div className="headerBookingPaymentMain">
                                            <h5>Tóm tắt giá</h5>
                                            <div className="chooseEndows" onClick={showEndowModal}>Chọn ưu đãi</div>
                                        </div>
                                        <ul>
                                            <li>
                                                <label htmlFor="">Giá bán</label>
                                                <span>42,549,000 VND</span>
                                            </li>
                                            <li>
                                                <label htmlFor="">Tạm tính</label>
                                                <span>42,549,000 VND</span>
                                            </li>
                                            <li className="totalPrice">
                                                <label htmlFor="">Tổng tiền</label>
                                                <span>42,549,000 VND</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="btnPayment payNow">
                                        <button><img className="img-fluid" src="/images/ic_payment_now.png" alt="" />Thanh toán ngay
                                            <span className="sale">Giảm <br /> 10%</span>
                                        </button>
                                    </div>
                                    <div className="btnPayment Postpaid">
                                        <button><img className="img-fluid" src="/images/ic_payment_method.png" alt="" />Thanh toán sau
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
            <Modal className="modalMedia" title={""} footer={false} visible={isModalVisible} width={900} onCancel={handleCancel}>
                <MediaModal img={Medias.image} />
            </Modal>
            <EndowModal endowModal={endowModal} setEndowModal={setEndowModal} />
        </>
    );
}
export default BookingRoom;